import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../core/service/app/account.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-confirmation-page',
  templateUrl: './confirmation-page.component.html'
})
export class ConfirmationPageComponent implements OnInit {
    email: string;
    private sub: any;

  constructor(
      private route: ActivatedRoute,
      private accountService: AccountService
      ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        this.email = params['email']; 
      });

    this.accountService.confirm(this.email).then(result => {
      if(result == "ok")
        {
          swal({ type: "success", title: "Gracias por confirmar su cuenta ahora puede ingresar para terminar su registro." }).then(result => 
          {
            this.accountService.reload();
          });
        }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/page/confirmation-Page/confirmation-page.component.ts